import { queryParse } from '../query'

/**
 * Parse a URL for routing use.
 */
export const urlParse = (url: string) => {
	const startOfPath = getStartOfPath(url)
	const startOfQuery = getNextOrEnd(url, startOfPath, /[?#]/g)
	const startOfFragment = getNextOrEnd(url, startOfQuery, /#/g)

	return {
		path: parsePath(url.slice(startOfPath, startOfQuery)),
		query: queryParse(url.slice(startOfQuery, startOfFragment)),
		fragment: decodeURIComponent(url.slice(startOfFragment + 1)) || undefined,
	}
}

const parsePath = (value: string) =>
	value
		.split(/\/+/)
		.filter((segment) => segment !== '')
		.map((value) => decodeURIComponent(value))

const getStartOfPath = (url: string) => {
	// Strip lead-up with schema and host if present
	// Use lastIndex, since this is the end position of the last match
	// Match against the start of the path separator, or the separators
	// that can end the path-section
	const leadingRegex = /^\/\/|:\/\//g
	if (leadingRegex.test(url)) {
		return getNextOrEnd(url, leadingRegex.lastIndex, /[/?#]/g)
	}
	if (url[0] === '/') {
		return 1
	}
	return 0
}

/** Get the position of the next match or the end of the string */
const getNextOrEnd = (url: string, startAt: number, match: RegExp) => {
	// Override last index to move regex search to next match
	match.lastIndex = startAt
	const result = match.exec(url)

	return result ? match.lastIndex - 1 : url.length
}
